import { render, staticRenderFns } from "./service.vue?vue&type=template&id=34227268&scoped=true"
import script from "./service.js?vue&type=script&lang=js&external"
export * from "./service.js?vue&type=script&lang=js&external"
import style0 from "./service.vue?vue&type=style&index=0&id=34227268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34227268",
  null
  
)

export default component.exports